import script from "./PaymentAutoOpenConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentAutoOpenConfig.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentAutoOpenConfig.vue?vue&type=style&index=0&id=f339f440&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f339f440"]])

export default __exports__